var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-code-container"},[_c('canvas',{ref:"verifyCanvas",staticClass:"verify-canvas",attrs:{"width":"120","height":"40"},on:{"click":_vm.refreshCode}})])}
var staticRenderFns = []

export { render, staticRenderFns }